import { createSlice } from '@reduxjs/toolkit';
import { getAllModelsAction } from 'redux/actions/model';

const initialState = {
  modelsLoading: false,
  models: [],
  loading: false,
};

// First import your thunk then add thunk lifecycle handlers
export const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllModelsAction.pending]: (state) => {
      state.loading = true;
    },
    [getAllModelsAction.fulfilled]: (state, action) => {
      state.models = action.payload.datamodels;
      state.loading = false;
    },
    [getAllModelsAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const { openFolder } = modelSlice.actions;
// export the reducer to be passed to configureStore
export default modelSlice.reducer;
